import type { BackendLesson, LessonTab } from '../types';
import { UnitStateKey } from '../../InProgressUnitsPanel/lessonStepState';

export const getUnitsForTab = (activeTab: LessonTab, backendLessons: BackendLesson[]): BackendLesson[] => {
    switch (activeTab) {
        case 'addTopics':
            return [];
        case 'review':
            return backendLessons.filter((unit: any) => {
                const state = unit.e251_State;
                if (unit.e251_AssessmentId && (!unit.e251_Lessons || unit.e251_Lessons.length === 0)) {
                    return false;
                }
                return state === UnitStateKey.Reviewing;
            });
        case 'inprogress':
            return backendLessons.filter((unit: any) => {
                const state = unit.e251_State;
                return (
                    state === UnitStateKey.Ready ||
                    state === UnitStateKey.InProgress ||
                    state === UnitStateKey.LessonsCompleted ||
                    state === UnitStateKey.Assessing
                );
            });
        case 'done':
            return backendLessons.filter((unit: any) => unit.e251_State === UnitStateKey.Complete);
        default:
            return [];
    }
};

export const getLearningStyleColor = (learningStyle: string): string => {
    switch (learningStyle) {
        case 'Conceptual':
            return 'text-blue-600 bg-blue-50';
        case 'Field Trip':
            return 'text-confirm-action bg-confirm-action/10';
        case 'Kinesthetic':
            return 'text-purple-600 bg-purple-50';
        default:
            return 'text-gray-600 bg-gray-50';
    }
};
